export function staticImplements<T> () {
  /* eslint-disable no-unused-expressions */
  return <U extends T>(constructor: U) => { constructor; };
}
